import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "#0052B4",
  d: "m39.13 20 .7-2.609c-.116-.889-.29-1.76-.519-2.608h-21.05V.076a19.95 19.95 0 0 0-2.609.4L12.174 2.61l-1.74-.176c-.914.5-1.786 1.068-2.608 1.7v10.65H.69c-.229.848-.403 1.72-.52 2.608L.87 20l-.7 2.609c.117.889.291 1.76.52 2.608h7.137v10.65c.822.632 1.694 1.2 2.609 1.7l2.608-.176 2.609 2.133c.85.188 1.721.323 2.609.4V25.217h21.05c.228-.848.403-1.72.52-2.608L39.13 20Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M39.83 17.391H15.652V.476a19.86 19.86 0 0 0-5.217 1.956v14.96H.17a20.198 20.198 0 0 0 0 5.217h10.265v14.96a19.86 19.86 0 0 0 5.217 1.955V22.609H39.83a20.21 20.21 0 0 0 0-5.218Z"
}, null, -1), a = [
  c,
  n,
  s
];
function h(d, r) {
  return t(), l("svg", o, [...a]);
}
const _ = { render: h };
export {
  _ as default,
  h as render
};
